// extracted by mini-css-extract-plugin
module.exports = {"overview":"CryptoRewardsOrderSuccessResultWarning__overview__j1DRu","bold":"CryptoRewardsOrderSuccessResultWarning__bold__vtLsD"};